/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import AbstractWorkerLogger, {
  AbstractWorkerLoggerType
} from './AbstractWorkerLogger';

/**
 * The WorkerClientLogger is to be used by Client Worker implementations to
 * log all aspects of the implementations status.
 */
export default class WorkerClientLogger extends AbstractWorkerLogger {
  /**
   * The WorkerClientLogger provides the logging facility for Web Worker APIs.
   *
   * @param context Provides the context of the Worker API, this generally
   *        should reflect the process which the worker reflects, such as
   *        notifications, etc.
   */
  constructor(context: string) {
    super(AbstractWorkerLoggerType.Client, context);
  }

  /**
   * To be invoked when a Client Worker implementation has been initialized.
   * This method is generally used internally by the AbstractWorker.
   */
  onInitialize = () => {
    this.log('Initialized');
  };

  /**
   * To be invoked by a Client Worker implementation when a message is sent to
   * the underlying worker script. This method is generally used internally by
   * the AbstractWorker.
   */
  onMessageSent = () => {
    this.log('Update Message Sent');
  };

  /**
   * To be invoked when a Client Worker implementation has received an incoming
   * message.  This method is generally used internally by the AbstractWorker.
   */
  onMessageReceived = () => {
    this.log('Update Message Received');
  };

  /**
   * To be invoked when a Client Worker implementation receives an incoming
   * message failure. This method is generally used internally by the
   * AbstractWorker.
   */
  onMessageError = (event: MessageEvent) => {
    this.log(`Message Error. ${event.toString()}`, true);
  };

  /**
   * To be invoked when a Client Worker implementation receives an error event.
   * This method is generally used internally by the AbstractWorker.
   */
  onError = (event: ErrorEvent) => {
    this.log(`Error. ${event.toString()}`, true);
  };

  /**
   * To be invoked when a Client Worker implementation receives is terminated.
   * This method is generally used internally by the AbstractWorker.
   */
  onDestruct = () => {
    this.log('Terminated');
  };
};
